module.exports = __webpack_public_path__ + "img/4.fbe7f806.jpg";